/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import MainHeader from '../header';
import MealtristHeader from '../Core/mealtristHeader';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import '../../App.css';
import 'font-awesome/css/font-awesome.css';
import swal from 'sweetalert';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6
import ImageCompressor from 'image-compressor.js';
import MealtristFooter from "../Core/mealtrist-footer";

class MealEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = { uploadUrl: "", messageStatus: "", successMessage: "", isAuthor: false, mealId: "", imgFile: "", loggedIn: false, name: "", mealCategory: "Choose Category", privacy: "Privacy Setting", calories: "", carbohydrates: "", cholesterol: "", fat: "", fiber: "", protein: "", saturatedFat: "", servingSize: "", sodium: "", sugar: "", transFat: "",unsaturatedFat: "", cookingTime: "", prepTime: "", totalCookTime: "", cookingMethod: "", cuisine: "", diet: "", ingredientCount: [{amount: "", measurement: "", item: "", specifics: ""}], ingredientAmount: "", ingredientItem: "", ingredientSpecifics: "", ingredientCategory: "Select Measurement", descriptions: "<br></br>", instructions: "<br></br>", mealRating: 3};
        this.createMarkup = this.createMarkup.bind(this);
        this.capitalizeWords = this.capitalizeWords.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleItemChange = this.handleItemChange.bind(this);
        this.handleSpecificsChange = this.handleSpecificsChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.onSelectMealCategory = this.onSelectMealCategory.bind(this);
        this.onSelectPrivacy = this.onSelectPrivacy.bind(this);
        this.onSelectIngredientCategory = this.onSelectIngredientCategory.bind(this);
        this.addIngredient = this.addIngredient.bind(this);
        this.handleCaloriesChange = this.handleCaloriesChange.bind(this);
        this.handleCarbChange = this.handleCarbChange.bind(this);
        this.handleCholesterolChange = this.handleCholesterolChange.bind(this);
        this.handleFatChange = this.handleFatChange.bind(this);
        this.handleSaturatedFatChange = this.handleSaturatedFatChange.bind(this);
        this.handleFiberChange = this.handleFiberChange.bind(this);
        this.handleServingSizeChange = this.handleServingSizeChange.bind(this);
        this.handleSodiumChange = this.handleSodiumChange.bind(this);
        this.handleSugarChange = this.handleSugarChange.bind(this);
        this.handleTransFatChange = this.handleTransFatChange.bind(this);
        this.handleProteinChange = this.handleProteinChange.bind(this);
        this.handleUnsaturatedFatChange = this.handleUnsaturatedFatChange.bind(this);
        this.handleCookingTimeChange = this.handleCookingTimeChange.bind(this);
        this.handlePrepTimeChange = this.handlePrepTimeChange.bind(this);
        this.handleTotalCookTimeChange = this.handleTotalCookTimeChange.bind(this);
        this.handleCookingMethodChange = this.handleCookingMethodChange.bind(this);
        this.handleCuisineChange = this.handleCuisineChange.bind(this);
        this.handleDietChange = this.handleDietChange.bind(this);
        this.onSelectMealRating = this.onSelectMealRating.bind(this);
        this.onSelectImage = this.onSelectImage.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.submitMeal = this.submitMeal.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleInstructionsChange = this.handleInstructionsChange.bind(this);
        this.deleteMealSwal = this.deleteMealSwal.bind(this);
        this.deleteMeal = this.deleteMeal.bind(this);
    }

    componentWillMount() {
    }

    capitalizeWords(str)
    {
        if(typeof(str) !== "undefined") {
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }
    }

    createMarkup(text) {
        return {__html: text};
    }

    deleteMealSwal(mealId) {
        swal({
            title: "Are you sure?",
            text: "Deleting the meal here will remove it permanently.",
            buttons: {
                cancel: "Cancel",
                category: {
                    text: "Delete Meal",
                    value: "meal",
                }
            },
            dangerMode: true,
            icon: "warning",
        })
            .then((value) => {
                switch (value) {
                    case "meal":
                        this.setState(prevState => ({
                            messageStatus: "loading"
                        }));
                        this.deleteMeal(mealId);
                        break;

                    default: break;
                }
            });
    }

    deleteMeal( mealId = 0)
    {
        if(mealId > 0) {
            console.log("updating category");
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/meal/delete/' + mealId,
                                        type: 'post',
                                        async: false,
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    messageStatus: "success"
                                                }));
                                                globalThis.setState(prevState => ({
                                                    successMessage: "Your meal has been successfully depleted"
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    onSelectImage(event) {
        event.preventDefault();
        let file = "";
        let reader = new FileReader();
        if (event.target.files) {
            file = event.target.files[0];
            let imgUrl = window.URL.createObjectURL(file);
            const imageCompressor = new ImageCompressor();
            console.log(file);
            imageCompressor.compress(file, {quality: .6})
                .then((result) => {
                    let blobName = result.name;
                    result = new File([result], blobName);
                })
                .catch((err) => {
                    // Handle the error
                });
            this.setState({imgFile: event.target.id});
            this.setState({uploadUrl: imgUrl});
        }
    }

    submitMeal() {
        this.setState(prevState => ({
            messageStatus: "loading"
        }));
        let currentImg = null;
        currentImg = document.getElementById(this.state.imgFile);
        let reader = new FileReader();
        let file = "";

        if(currentImg && currentImg.files) {
            file = currentImg.files[0];
        }
        const imageCompressor = new ImageCompressor();
        imageCompressor.compress(file, {quality: .6})
            .then((result) => {
                let blobName = result.name;
                result = new File([result], blobName);
                file = result;
            })
            .catch((err) => {
                // Handle the error
            });
        let name = this.state.name;

        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        let serve = false;
        if (typeof(file.type) !== 'undefined') {
            if(!!file.type.match(/image.*/)) {
                serve = true;
            }
        }
        if(typeof(file.type) === 'undefined') {
            serve = true;
        }

        if (serve) {
            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    if (typeof(response.data.id) !== 'undefined') {
                                        let myFormData = new FormData();
                                        myFormData.append('image[]', file);
                                        myFormData.append('id', globalThis.state.mealId);
                                        myFormData.append('name', name);
                                        myFormData.append('privacy', globalThis.state.privacy);
                                        myFormData.append('calories', globalThis.state.calories);
                                        myFormData.append('carbohydrates', globalThis.state.carbohydrates);
                                        myFormData.append('cholesterol', globalThis.state.cholesterol);
                                        myFormData.append('fat', globalThis.state.fat);
                                        myFormData.append('fiber', globalThis.state.fiber);
                                        myFormData.append('protein', globalThis.state.protein);
                                        myFormData.append('saturatedFat', globalThis.state.saturatedFat);
                                        myFormData.append('servingSize', globalThis.state.servingSize);
                                        myFormData.append('sodium', globalThis.state.sodium);
                                        myFormData.append('sugar', globalThis.state.sugar);
                                        myFormData.append('transFat', globalThis.state.transFat);
                                        myFormData.append('unsaturatedFat', globalThis.state.unsaturatedFat);
                                        myFormData.append('cookingTime', globalThis.state.cookingTime);
                                        myFormData.append('prepTime', globalThis.state.prepTime);
                                        myFormData.append('totalCookTime', globalThis.state.totalCookTime);
                                        myFormData.append('cookingMethod', globalThis.state.cookingMethod);
                                        myFormData.append('cuisine', globalThis.state.cuisine);
                                        myFormData.append('diet', globalThis.state.diet);
                                        myFormData.append('descriptions', globalThis.state.descriptions);
                                        myFormData.append('instructions', globalThis.state.instructions);
                                        myFormData.append('mealRating', globalThis.state.mealRating);
                                        myFormData.append('mealCategory', globalThis.state.mealCategory);
                                        myFormData.append('ingredientCount', JSON.stringify(globalThis.state.ingredientCount));


                                        //TESTING COMPLETE ORDERS
                                        $.ajax({
                                            url: process.env.REACT_APP_API_HOST + '/' + 'api/meal/edit',
                                            type: "POST",
                                            data: myFormData,
                                            processData: false,
                                            contentType: false,
                                            'headers': {
                                                // Use access_token previously retrieved from inContact token
                                                // service.
                                                'Authorization': 'Bearer ' + user.token,
                                            },
                                            error: function (response) {
                                                //Failed response
                                                // logOrderError(visitID, 'otsError', completeOrderData, response);
                                            },
                                            success: function (response) {
                                                console.log('image response');
                                                console.log(response);
                                                globalThis.setState(prevState => ({
                                                    messageStatus: "success"
                                                }));
                                                globalThis.setState(prevState => ({
                                                    successMessage: "Your meal has been successfully updated!"
                                                }));
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    componentDidMount() {
        let mealId = Number(this.props.match.params.id);
        this.setState(prevState => ({
            mealId: mealId
        }));
        if(mealId && mealId !== '' && mealId === parseInt(mealId, 10)) {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (authResponse) {
                        if (typeof(authResponse.message) !== 'undefined') {
                            if (authResponse.message.indexOf('authenticated_user') > -1) {
                                if (typeof(authResponse.data) !== 'undefined') {
                                    if (typeof(authResponse.data.id) !== 'undefined') {
                                        globalThis.setState(prevState => ({
                                            loggedIn: 'true'
                                        }));
                                        $.ajax({
                                            url: process.env.REACT_APP_API_HOST + '/' + 'api/meal/show/' + mealId,
                                            type: 'post',
                                            async: false,
                                            'headers': {
                                                // Use access_token previously retrieved from inContact token
                                                // service.
                                                'Authorization': 'Bearer ' + user.token,
                                            },
                                            error: function (response) {
                                                //Failed response
                                                // logOrderError(visitID, 'otsError', completeOrderData, response);
                                            },
                                            success: function (response) {
                                                if(typeof (response) !== 'undefined') {
                                                    if(response.meal) {
                                                        if(authResponse.data.id == response.meal.user_id) {
                                                            globalThis.setState(prevState => ({
                                                                isAuthor: 'true'
                                                            }));
                                                        }
                                                        globalThis.setState(prevState => ({
                                                            name: response.meal.name
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            privacy: response.meal.privacy
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            calories: response.meal.calories
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            carbohydrates: response.meal.carbohydrates
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            cholesterol: response.meal.cholesterol
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            cholesterol: response.meal.cholesterol
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            fat: response.meal.fat
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            fiber: response.meal.fiber
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            protein: response.meal.protein
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            saturatedFat: response.meal.saturatedFat
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            sodium: response.meal.sodium
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            sugar: response.meal.sugar
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            transFat: response.meal.transFat
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            unsaturatedFat: response.meal.unsaturatedFat
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            cookingTime: response.meal.cookingTime
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            prepTime: response.meal.prepTime
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            totalCookTime: response.meal.totalCookTime
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            cookingMethod: response.meal.cookingMethod
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            cuisine: response.meal.cuisine
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            diet: response.meal.diet
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            descriptions: response.meal.description
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            instructions: response.meal.instructions
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            mealRating: response.meal.rating
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            mealCategory: response.meal.course
                                                        }));
                                                        globalThis.setState(prevState => ({
                                                            uploadUrl: response.meal.picture
                                                        }));
                                                    }
                                                    globalThis.setState(prevState => ({
                                                        ingredientCount: response.ingredients
                                                    }));
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }


    handleDietChange(event) {
            this.setState({diet: event.target.value});
    }


    handleCuisineChange(event) {
            this.setState({cuisine: event.target.value});
    }


    handleCookingMethodChange(event) {
            this.setState({cookingMethod: event.target.value});
    }

    handleTotalCookTimeChange(event) {
            this.setState({totalCookTime: event.target.value});
    }

    handlePrepTimeChange(event) {
            this.setState({prepTime: event.target.value});
    }

    handleCookingTimeChange(event) {
            this.setState({cookingTime: event.target.value});
    }

    handleUnsaturatedFatChange(event) {
            this.setState({unsaturatedFat: event.target.value});
    }

    handleProteinChange(event) {
            this.setState({protein: event.target.value});
    }

    handleTransFatChange(event) {
            this.setState({transFat: event.target.value});
    }

    handleSugarChange(event) {
            this.setState({sugar: event.target.value});
    }

    handleSodiumChange(event) {
            this.setState({sodium: event.target.value});
    }

    handleServingSizeChange(event) {
            this.setState({servingSize: event.target.value});
    }

    handleFiberChange(event) {
            this.setState({fiber: event.target.value});
    }

    handleSaturatedFatChange(event) {
            this.setState({saturatedFat: event.target.value});
    }

    handleFatChange(event) {
            this.setState({fat: event.target.value});
    }

    handleCholesterolChange(event) {
            this.setState({cholesterol: event.target.value});
    }

    handleCarbChange(event) {
            this.setState({carbohydrates: event.target.value});
    }

    handleCaloriesChange(event) {
            this.setState({calories: event.target.value});
    }

    handleNameChange(event) {
            this.setState({name: event.target.value});
    }

    handleDescriptionChange(event) {
        this.setState({descriptions: event});
    }

    handleInstructionsChange(event) {
        this.setState({instructions: event});
    }

    addIngredient() {
        let newIngredient = {
            amount: "",
            measurement: "",
            item: "",
            specifics: ""
        }

        this.state.ingredientCount.push(newIngredient);
        this.setState({ingredientCount: this.state.ingredientCount });
    }

    handleAmountChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

        var re = /[0-9.]/g;
        var myString = currentValue.match(re);
        var newString = '';
        if (myString && myString.length !== 0) {
            for(var i = 0; i < myString.length; i++) {
                newString += myString[i];
            }
            currentValue = newString;
        } else {
            currentValue = "";
        }

        if (this.state.ingredientCount[currentId]) {
            if (typeof this.state.ingredientCount[currentId].amount !== "undefined") {
                this.state.ingredientCount[currentId].amount = currentValue;
            }
        }
        this.setState({ingredientCount: this.state.ingredientCount });
    }

    handleItemChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

        if (this.state.ingredientCount[currentId]) {
            if (typeof this.state.ingredientCount[currentId].item !== "undefined") {
                this.state.ingredientCount[currentId].item = currentValue;
            }
        }
        this.setState({ingredientCount: this.state.ingredientCount });
    }

    handleSpecificsChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

        if (this.state.ingredientCount[currentId]) {
            if (typeof this.state.ingredientCount[currentId].specifics !== "undefined") {
                this.state.ingredientCount[currentId].specifics = currentValue;
            }
        }
        this.setState({ingredientCount: this.state.ingredientCount });
    }



    handleKeyUp(e) {
        var globalThis = this;
        if (e.keyCode === 13) {
            globalThis.triggerChange();
        }
    }

    onSelectMealRating(eventKey) {
        this.setState({mealRating: eventKey });
    }

    onSelectMealCategory(eventKey) {
        this.setState({mealCategory: eventKey });
    }

    onSelectIngredientCategory(e, event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.getAttribute('data-value');

        if (this.state.ingredientCount[currentId]) {
            if (typeof this.state.ingredientCount[currentId].measurement !== "undefined") {
                this.state.ingredientCount[currentId].measurement = currentValue;
            }
        }
        this.setState({ingredientCount: this.state.ingredientCount });
    }

    onSelectPrivacy(eventKey) {
        this.setState({privacy: eventKey });
    }

    //TODO set referrer url link in containers first child link
    render() {
        console.log('loggin message state');
        console.log(this.state.isAuthor);
        console.log(this.state.loggedIn);

        const header = {
            use: ""
        }
        let output = "";
        let ingredientForm = "";

        ingredientForm = this.state.ingredientCount.map((ingredient, ingredientIndex) => {
            let measurementTitle = "Select Measurement";
            let ingredientAmount = "";
            let ingredientItem = "";
            let ingredientSpecifics = "";
            if(ingredient.amount !== "") {
                ingredientAmount = ingredient.amount;
            }
            if(ingredient.measurement !== "") {
                measurementTitle = ingredient.measurement;
            }
            if(ingredient.item !== "") {
                ingredientItem = ingredient.item;
            }
            if(ingredient.specifics !== "") {
                ingredientSpecifics = ingredient.specifics;
            }
            return <div key={ingredientIndex + "ingredient"}>
                <br></br>
                <div className="row">
                    <ReactBootstrap.Form inline>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientAmount">
                                <ReactBootstrap.FormControl type="text" data-id={ingredientIndex} value={ingredientAmount} onChange={this.handleAmountChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Amount" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientMeasurement">
                                <ReactBootstrap.SplitButton title={this.capitalizeWords(measurementTitle)} pullRight id="split-button-pull-right" bsSize="large">
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="unit" onSelect={this.onSelectIngredientCategory}>Package/Unit(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="teaspoon" onSelect={this.onSelectIngredientCategory}>Teaspoon(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="tablespoon" onSelect={this.onSelectIngredientCategory}>Tablespoon(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="cup" onSelect={this.onSelectIngredientCategory}>Cup(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="pound" onSelect={this.onSelectIngredientCategory}>Pound(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="ounces" onSelect={this.onSelectIngredientCategory}>Ounce(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="fluid ounce" onSelect={this.onSelectIngredientCategory}>Fluid Ounce(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="pint" onSelect={this.onSelectIngredientCategory}>Pint(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="quart" onSelect={this.onSelectIngredientCategory}>Quart(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id={ingredientIndex} data-value="gallon" onSelect={this.onSelectIngredientCategory}>Gallon(s)</ReactBootstrap.MenuItem>
                                </ReactBootstrap.SplitButton>
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientItem">
                                <ReactBootstrap.FormControl type="text" data-id={ingredientIndex} value={ingredientItem} onChange={this.handleItemChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Item" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientAmount">
                                <ReactBootstrap.FormControl type="text" data-id={ingredientIndex} value={ingredientSpecifics} onChange={this.handleSpecificsChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Specifics" />
                            </ReactBootstrap.FormGroup>
                        </div>
                    </ReactBootstrap.Form>
                </div>
                {(ingredientIndex + 1) === this.state.ingredientCount.length &&
                <div>
                    <div className="row">
                <br></br>
                <div className="col-sm-3">
                </div>
                        <div className="col-sm-6">
                <ReactBootstrap.ButtonToolbar>
                    <ReactBootstrap.Button bsSize="large" onClick={this.addIngredient}>Add Ingredient</ReactBootstrap.Button>
                </ReactBootstrap.ButtonToolbar>
                </div>
                        <div className="col-sm-3"></div>
                    </div>
                </div>
                }
            </div>
        });

        let form = "";
        form =  <div>
            <div className="row">
                <ReactBootstrap.Form inline>
            <div className="col-md-4 col-xs-12">
                <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                    <ReactBootstrap.FormControl type="text" value={this.state.name} onChange={this.handleNameChange}
                                                 placeholder="Name" />
                </ReactBootstrap.FormGroup>
            </div>

            <div className="col-md-4 col-xs-12">
                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                        <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.mealCategory)} pullRight id="split-button-pull-right" bsSize="large">
                            <ReactBootstrap.MenuItem eventKey="main dishes" onSelect={this.onSelectMealCategory}>Main Dishes</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="appetizer" onSelect={this.onSelectMealCategory}>Appetizer</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="beverages" onSelect={this.onSelectMealCategory}>Beverages</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="breads" onSelect={this.onSelectMealCategory}>Breads</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="desserts" onSelect={this.onSelectMealCategory}>Desserts</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="finger foods" onSelect={this.onSelectMealCategory}>Finger Foods</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="salads" onSelect={this.onSelectMealCategory}>Salads</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="side dishes" onSelect={this.onSelectMealCategory}>Side Dishes</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="snacks" onSelect={this.onSelectMealCategory}>Snacks</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="soups and stew" onSelect={this.onSelectMealCategory}>Soups & Stew</ReactBootstrap.MenuItem>
                        </ReactBootstrap.SplitButton>
                    </ReactBootstrap.FormGroup>
            </div>

                <div className="col-md-4 col-xs-12">
                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                        <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.privacy)} pullRight id="split-button-pull-right" bsSize="large">
                            <ReactBootstrap.MenuItem eventKey="public" onSelect={this.onSelectPrivacy}>Public</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="friends" onSelect={this.onSelectPrivacy}>Friends Only</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="family" onSelect={this.onSelectPrivacy}>Family Only</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="topFriends" onSelect={this.onSelectPrivacy}>Top Friends</ReactBootstrap.MenuItem>
                            <ReactBootstrap.MenuItem eventKey="secret" onSelect={this.onSelectPrivacy}>Secret</ReactBootstrap.MenuItem>
                        </ReactBootstrap.SplitButton>
                    </ReactBootstrap.FormGroup>
                </div>
            </ReactBootstrap.Form>
            </div>
                <br></br>
            <div className="row">

                <ReactBootstrap.Form>
                    <div className="col-md-2 col-sm-4 col-xs-6">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formCalories">
                            <ReactBootstrap.FormControl type="text" value={this.state.calories} onChange={this.handleCaloriesChange}
                                                        onKeyUp={this.handleKeyUp} placeholder="Calories" />
                        </ReactBootstrap.FormGroup>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-6">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formCarbohydrates">
                            <ReactBootstrap.FormControl type="text" value={this.state.carbohydrates} onChange={this.handleCarbChange}
                                                        onKeyUp={this.handleKeyUp} placeholder="Carbohydrates" />
                        </ReactBootstrap.FormGroup>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-6">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formCholesterol">
                            <ReactBootstrap.FormControl type="text" value={this.state.cholesterol} onChange={this.handleCholesterolChange}
                                                        onKeyUp={this.handleKeyUp} placeholder="Cholesterol" />
                        </ReactBootstrap.FormGroup>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-6">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formFat">
                            <ReactBootstrap.FormControl type="text" value={this.state.fat} onChange={this.handleFatChange}
                                                        onKeyUp={this.handleKeyUp} placeholder="Fat" />
                        </ReactBootstrap.FormGroup>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-6">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formFiber">
                            <ReactBootstrap.FormControl type="text" value={this.state.fiber} onChange={this.handleFiberChange}
                                                        onKeyUp={this.handleKeyUp} placeholder="Fiber" />
                        </ReactBootstrap.FormGroup>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-6">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formProtein">
                            <ReactBootstrap.FormControl type="text" value={this.state.protein} onChange={this.handleProteinChange}
                                                        onKeyUp={this.handleKeyUp} placeholder="Protein" />
                        </ReactBootstrap.FormGroup>
                    </div>
                </ReactBootstrap.Form>
            </div>
                <br></br>
                <div className="row">

                    <ReactBootstrap.Form>
                        <div className="col-md-2 col-sm-4 col-xs-6">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formSaturatedFat">
                                <ReactBootstrap.FormControl type="text" value={this.state.saturatedFat} onChange={this.handleSaturatedFatChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Saturated Fat" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-2 col-sm-4 col-xs-6">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formServingSize">
                                <ReactBootstrap.FormControl type="text" value={this.state.servingSize} onChange={this.handleServingSizeChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Serving Size" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-2 col-sm-4 col-xs-6">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formSodium">
                                <ReactBootstrap.FormControl type="text" value={this.state.sodium} onChange={this.handleSodiumChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Sodium" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-2 col-sm-4 col-xs-6">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formSugar">
                                <ReactBootstrap.FormControl type="text" value={this.state.sugar} onChange={this.handleSugarChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Sugar" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-2 col-sm-4 col-xs-6">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formTransFat">
                                <ReactBootstrap.FormControl type="text" value={this.state.transFat} onChange={this.handleTransFatChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="TransFat" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-2 col-sm-4 col-xs-6">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formUnsaturatedFat">
                                <ReactBootstrap.FormControl type="text" value={this.state.unsaturatedFat} onChange={this.handleUnsaturatedFatChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Unsaturated Fat" />
                            </ReactBootstrap.FormGroup>
                        </div>
                    </ReactBootstrap.Form>
                </div>
                <br></br>
                <h2 className="text-center">Cooking Time</h2>
                <div className="row">
                    <ReactBootstrap.Form inline>
                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formCookingTime">
                                <ReactBootstrap.FormControl type="text" value={this.state.cookingTime} onChange={this.handleCookingTimeChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Cooking Time" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formPrepTime">
                                <ReactBootstrap.FormControl type="text" value={this.state.prepTime} onChange={this.handlePrepTimeChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Prep Time" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formTotalCookTime">
                                <ReactBootstrap.FormControl type="text" value={this.state.totalCookTime} onChange={this.handleTotalCookTimeChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Total Cook Time" />
                            </ReactBootstrap.FormGroup>
                        </div>
                    </ReactBootstrap.Form>
                </div>
                <br></br>
                <h2 className="text-center">Cooking Details</h2>
                <div className="row">
                    <ReactBootstrap.Form inline>
                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formCookingMethod">
                                <ReactBootstrap.FormControl type="text" value={this.state.cookingMethod} onChange={this.handleCookingMethodChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Cooking Method" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formCuisine">
                                <ReactBootstrap.FormControl type="text" value={this.state.cuisine} onChange={this.handleCuisineChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Cuisine" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formDiet">
                                <ReactBootstrap.FormControl type="text" value={this.state.diet} onChange={this.handleDietChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Diet" />
                            </ReactBootstrap.FormGroup>
                        </div>
                    </ReactBootstrap.Form>
                </div>
                <div>
                    <br></br>
                    <h2 className="text-center">Ingredients</h2>
                {ingredientForm}
                </div>
                <div className="row">
                    <h2 className="text-center">Details</h2>
                    <h4>Description</h4>
                    <br></br>
                    <ReactQuill id="mealDescription" onChange={this.handleDescriptionChange} value={this.state.descriptions}  />
                    <br></br>
                    <h4>Instructions</h4>
                    <br></br>
                    <ReactQuill id="mealInstructions" onChange={this.handleInstructionsChange} value={this.state.instructions}  />
                </div>
                <br></br>
                <div className="row">
                    <div className="col-md-4 col-xs-12">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formControlsFile">
                            <ReactBootstrap.ControlLabel>File</ReactBootstrap.ControlLabel>
                            <ReactBootstrap.FormControl onChange={this.onSelectImage} type="file" accept="image/*"/>
                            <ReactBootstrap.HelpBlock>Please upload meal image here.</ReactBootstrap.HelpBlock>
                        </ReactBootstrap.FormGroup>
                    </div>
                    <div className="col-md-4 col-xs-12">
                        {this.state.uploadUrl !== "" &&
                            <img src={this.state.uploadUrl} height="85%" width="55%" />
                        }
                    </div>
                    <div className="col-md-4 col-xs-12">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                            <ReactBootstrap.SplitButton title={this.state.mealRating} pullRight id="split-button-pull-right" bsSize="large">
                                <ReactBootstrap.MenuItem eventKey="1" onSelect={this.onSelectMealRating}>1</ReactBootstrap.MenuItem>
                                <ReactBootstrap.MenuItem eventKey="2" onSelect={this.onSelectMealRating}>2</ReactBootstrap.MenuItem>
                                <ReactBootstrap.MenuItem eventKey="3" onSelect={this.onSelectMealRating}>3</ReactBootstrap.MenuItem>
                                <ReactBootstrap.MenuItem eventKey="4" onSelect={this.onSelectMealRating}>4</ReactBootstrap.MenuItem>
                                <ReactBootstrap.MenuItem eventKey="5" onSelect={this.onSelectMealRating}>5</ReactBootstrap.MenuItem>
                            </ReactBootstrap.SplitButton>
                        </ReactBootstrap.FormGroup>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <ReactBootstrap.ButtonToolbar>
                            <ReactBootstrap.Button bsSize="large" onClick={this.submitMeal}>Update Meal</ReactBootstrap.Button>
                        </ReactBootstrap.ButtonToolbar>
                    </div>
                </div>
        </div>
        if(this.state.loggedIn === 'true') {
            header.use = <MealtristHeader/>;
            output = <div>
                {header.use}
                <div className="container main-body-content">
                    {this.state.messageStatus === "loading" &&
                    <div>
                        <div className="row">
                            <br></br>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                                <i className="text-center fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.messageStatus === "success" &&
                    <div>
                        <div className="row">
                            <br></br>
                            <div className="text-center">
                                <h2 className="text-danger">{this.state.successMessage}.</h2>
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.messageStatus === "" && this.state.isAuthor === 'true' &&
                        <div>
                    <div className="row">
                        <div className="col-sm-9">
                        </div>
                        <div className="col-sm-3">
                            <div className="col-sm-12">
                                <div className="col-sm-6">
                                    <Link to={'/meal-show/' + this.state.mealId}>
                                        <ReactBootstrap.ButtonToolbar>
                                            <ReactBootstrap.Button bsSize="small">Cancel</ReactBootstrap.Button>
                                        </ReactBootstrap.ButtonToolbar>
                                    </Link>
                                </div>
                                <div className="col-sm-6">
                                    <ReactBootstrap.ButtonToolbar>
                                        <ReactBootstrap.Button bsSize="small"
                                                               onClick={this.deleteMealSwal.bind(this, this.state.mealId)}>Delete
                                            Meal</ReactBootstrap.Button>
                                    </ReactBootstrap.ButtonToolbar>
                                </div>
                            </div>
                        </div>
                    </div>
                    < h1 className="text-center">Edit Meal</h1>
                        <br></br>
                    {form}
                        </div>
                    }
                </div>
                <MealtristFooter/>
            </div>
        } else {
            header.use = <MainHeader/>;
            output =
                <div>
                    {header.use}
                    <div className="text-center main-body-content">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                    </div>
                    <MealtristFooter/>
                </div>
        }
        return (
                output
        );
    }
}

export default MealEdit;


// WEBPACK FOOTER //
// ./src/components/Mealtrist/mealEdit.js